export const updateNestedValue = (obj: Record<string, unknown>, newValue: any = []) => {
  Object.keys(obj).forEach((key) => {
    if (Array.isArray(obj[key])) {
      obj[key] = newValue
    } else if (typeof obj[key] === 'boolean') {
      obj[key] = newValue
    } else {
      updateNestedValue(obj[key] as Record<string, unknown>, newValue)
    }
  })
  return obj
}
